import { FinalGrade } from 'app/library/final-grade/models/final-grade.model';
import { MaxbrainImage } from 'app/library/image-library/models/maxbrain-image.model';
import { ModuleUserProgress } from 'app/library/module-user/models/module-user-progress.model';
import { ModuleKind } from 'app/library/module/enums/module-kind.enum';
import { IRelevantExecutionQuery } from '../interfaces/relevant-execution.query.interface';
import { SectionRule } from 'app/library/module/enums/sectionRule.enum';
import { ModuleCategory } from 'app/library/module/enums/moduleCategory';

export class RelevantExecution {
    id: string;
    name: string;
    startDate: Date;
    endDate: Date;
    image: MaxbrainImage;
    type: string;
    participantCount: number;
    participantCompletedCount: number;
    participantFailedCount: number;
    participantPassedCount: number;
    isExecutionGraded: boolean;
    progress?: ModuleUserProgress;
    finalGrade?: FinalGrade;
    kind: ModuleKind;
    isManager: boolean;
    sectionRule: SectionRule;
    status: ModuleCategory;
    isDefault?: boolean;
    isSelected?: boolean; // Frontend property
    selfPaced: boolean;

    constructor(relevantExecutionQuery?: IRelevantExecutionQuery) {
        if (relevantExecutionQuery) {
            this.id = relevantExecutionQuery.id.toString();
            this.name = relevantExecutionQuery.name.toString();
            this.startDate = relevantExecutionQuery.start_date;
            this.endDate = relevantExecutionQuery.end_date;
            this.image = relevantExecutionQuery.image ? new MaxbrainImage(relevantExecutionQuery.image) : null;
            this.type = relevantExecutionQuery.type;
            this.participantCount = relevantExecutionQuery.participant_count;
            this.participantCompletedCount = relevantExecutionQuery.participant_completed_count;
            this.participantPassedCount = relevantExecutionQuery.participant_passed_count;
            this.participantFailedCount = relevantExecutionQuery.participant_failed_count;
            this.isExecutionGraded = relevantExecutionQuery.is_execution_graded;
            this.kind = relevantExecutionQuery.kind;
            this.isManager = relevantExecutionQuery.is_manager;
            this.sectionRule = relevantExecutionQuery.section_rule;
            this.status = relevantExecutionQuery.status;
            this.isDefault = relevantExecutionQuery.is_default;
            this.selfPaced = relevantExecutionQuery.self_paced;
        }
    }
}
